import { MenuItem } from "../props/CommonPropTypes";

export const useMenuItems = () => {
  const mainMenuItemList: MenuItem[] = [
    {
      id: "btn-application-main-menu-home",
      className: "btn-application-main-menu",
      title: "Home",
      path: "/home",
      matchPaths: ["/"],
    },
    {
      id: "btn-application-main-menu-apps",
      className: "btn-application-main-menu",
      title: "Apps",
      path: "/apps",
    },
    {
      id: "btn-application-main-menu-games",
      className: "btn-application-main-menu",
      title: "Games",
      path: "/games",
    },
    {
      id: "btn-application-main-menu-engineering",
      className: "btn-application-main-menu",
      title: "Engineering",
      path: "/engineering",
    },
    {
      id: "btn-application-main-menu-contact",
      className: "btn-application-main-menu",
      title: "Contact",
      path: "/contact",
    },
  ];

  return { mainMenuItemList };
};
